import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../App";

export default function Layout({ children }) {
  const { auth, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  function handleLogout() {
    logout();
    navigate("/");
  }

  const isAdmin = auth?.user?.rol === "admin";

  const adminLinks = [
    { to: "/admin/dashboard", label: "Resumen" },
    { to: "/admin/recibos",   label: "Recibos" },
    { to: "/admin/empleados", label: "Empleados" },
  ];

  return (
    <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      <header style={{
        background: "var(--navy)",
        color: "white",
        padding: "0 24px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        height: 60,
        boxShadow: "0 2px 6px rgba(0,0,0,.15)",
        flexShrink: 0,
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: 32 }}>
          <img src="/logo.png" alt="FRICSA" style={{ height: 36 }} />
          {isAdmin && (
            <nav style={{ display: "flex", gap: 4 }}>
              {adminLinks.map(l => (
                <Link key={l.to} to={l.to} style={{
                  color: location.pathname === l.to ? "white" : "rgba(255,255,255,.65)",
                  textDecoration: "none",
                  fontSize: 14,
                  fontWeight: 600,
                  padding: "6px 14px",
                  borderRadius: "var(--radius)",
                  background: location.pathname === l.to ? "rgba(255,255,255,.12)" : "transparent",
                  transition: "background .15s",
                }}>{l.label}</Link>
              ))}
            </nav>
          )}
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
          <span style={{ fontSize: 13, color: "rgba(255,255,255,.75)" }}>
            {auth?.user?.nombre}
            {isAdmin && <span style={{ marginLeft: 6, fontSize: 11, opacity: .7, textTransform: "uppercase" }}>Admin</span>}
          </span>
          <button className="btn btn-sm" onClick={handleLogout}
            style={{ border: "1.5px solid rgba(255,255,255,.4)", color: "white", background: "transparent" }}>
            Salir
          </button>
        </div>
      </header>

      <main style={{ flex: 1, padding: "32px 24px", maxWidth: 1100, margin: "0 auto", width: "100%" }}>
        {children}
      </main>
    </div>
  );
}
